import * as React from 'react';

import { useGetter, useEffect } from './slots';

interface Props {
    children: (x: Record<string, any>) => React.ReactNode
}

const Component: React.FunctionComponent<Props> = ({ children }) => {
    const [cursorMove] =   useEffect('cursorMove');
    const [changeValue] =  useEffect('changeValue');
    const [changeTarget] = useEffect('changeTarget');
    const target =         useGetter('target');

    const x = React.useMemo(() => {
        return target.getValue() || {};
    }, [cursorMove, changeValue, changeTarget]);

    return (
        <React.Fragment>
            {children(x)}
        </React.Fragment>
    );
}

export default Component;
